import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'app-list',
  template: '<ng-content></ng-content>',
  styleUrls: ['./list.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: { class: 'app-list' },
})
export class ListComponent {
  @Input() smallPadding: boolean;
}

@Component({
  selector: 'app-list-item',
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: { class: 'app-list-item' },
})
export class ListItemComponent implements AfterViewInit {
  @HostBinding('class.app-list-item-small') small;

  constructor(private list: ListComponent) {}

  ngAfterViewInit(): void {
    this.small = this.list.smallPadding;
  }
}
